import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const ThreatTypeChart = ({ analyticsData = [], dataColors, height = 350 }) => {
  const chartPieGradientColors = getChartColorsArray(dataColors);

  const labels = analyticsData.map(item => item.type);
  const series = analyticsData.map(item => parseInt(item.count, 10));

  const totalThreats = analyticsData.reduce(
    (sum, item) => sum + parseInt(item.count, 10),
    0
  );

  const options = {
    chart: {
      height: height - 100,
      type: "donut",
      animations: { enabled: true, easing: "easeinout", speed: 800 },
      toolbar: { show: false },
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        expandOnClick: true,
        donut: {
          size: "60%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total Threats",
              formatter: () => totalThreats,
              style: { fontSize: "16px", fontWeight: 600 },
            },
           
          },
        },
      },
    },
    dataLabels: {
      enabled: false, 
    },
    stroke: { width: 2, colors: ["#797777"] },
    fill: { type: "solid" },

    legend: {
  show: false,
  position: "bottom", 
  formatter: function (seriesName, opts) {
    const value = opts.w.globals.series[opts.seriesIndex];
    return seriesName + ": " + value;
  }
},

    labels,
    colors: chartPieGradientColors,
    tooltip: {
  enabled: true,
  y: {
    formatter: (val, { seriesIndex }) => {
      const realCount = parseInt(analyticsData[seriesIndex].count, 10);
      const label = labels[seriesIndex]; 
      return `${label}: ${realCount} threats (${(
        (realCount / totalThreats) * 100
      ).toFixed(2)}%)`;
    }
  }
}
,
  };

  if (series.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-muted">No threat data available</p>
      </div>
    );
  }

  return (
    <ReactApexChart
      className="apex-charts"
      series={series}
      options={options}
      type="donut"
      height={300}
    />
  );
};

export { ThreatTypeChart };
